import { create } from 'zustand';

import { Application, ApplicationConfig, ApplicationEnv } from '../lib/application';

interface ApplicationStoreValue {
	isInitialized: boolean;
	application: Application;
	initialize: (env: ApplicationEnv, config: ApplicationConfig) => void;
}

export const useApplication = create<ApplicationStoreValue>((set) => ({
	application: new Application(),
	initialize: (env: ApplicationEnv, config: ApplicationConfig) => set({ isInitialized: true, application: new Application(env, config) }),
	isInitialized: false,
}));
